import {ALLOWED_IMAGE_TYPES, MAX_IMAGE_SIZE_BYTES} from '../../../common/constants/assetUpload'
import {loadImageAsDataUrl} from '../../../common/utils/spriteUpload'

export type IconLoadErrorKey = 'invalidType' | 'tooLarge' | 'failed'

export class IconLoadError extends Error {
  readonly key: IconLoadErrorKey
  constructor(key: IconLoadErrorKey) {
    super(key)
    this.key = key
  }
}

const loadImageFromUrl = (url: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = () => reject(new IconLoadError('failed'))
    img.src = url
  })

export const loadIconImageFile = async (file: File): Promise<HTMLImageElement> => {
  if (!ALLOWED_IMAGE_TYPES.has(file.type)) throw new IconLoadError('invalidType')
  if (file.size > MAX_IMAGE_SIZE_BYTES) throw new IconLoadError('tooLarge')
  const dataUrl = await loadImageAsDataUrl(file)
  return loadImageFromUrl(dataUrl)
}
